/**
 * The gathering a launch names — C-021 (`FND-1616`).
 *
 * The bot's reminder about one gathering carries `s_<session id>` since C-021; before it, the
 * same button carried `schedule` and opened the list. `launch.ts` is a byte-identical port of
 * the old app's (FND-006, FND-912) and the old app never knew this prefix, so the start_param
 * arrives here as its `unknown` and is read here rather than there.
 */

import type { LaunchIntent } from './launch';

const GATHERING_PREFIX = 's_';

export function gatheringOf(intent: LaunchIntent): string | null {
  if (intent.kind !== 'unknown' || !intent.raw.startsWith(GATHERING_PREFIX)) return null;
  const sessionId = intent.raw.slice(GATHERING_PREFIX.length);
  return sessionId === '' ? null : sessionId;
}
